var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.02637C3 9.35245 3.52678 10.6242 4.46447 11.5619C5.40215 12.4996 6.67392 13.0264 8 13.0264C9.32608 13.0264 10.5979 12.4996 11.5355 11.5619C12.4732 10.6242 13 9.35245 13 8.02637C13 6.70028 12.4732 5.42852 11.5355 4.49083C10.5979 3.55315 9.32608 3.02637 8 3.02637C6.67392 3.02637 5.40215 3.55315 4.46447 4.49083C3.52678 5.42852 3 6.70028 3 8.02637Z",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.0264C13 18.0872 13.4214 19.1046 14.1716 19.8548C14.9217 20.6049 15.9391 21.0264 17 21.0264C18.0609 21.0264 19.0783 20.6049 19.8284 19.8548C20.5786 19.1046 21 18.0872 21 17.0264C21 15.9655 20.5786 14.9481 19.8284 14.1979C19.0783 13.4478 18.0609 13.0264 17 13.0264C15.9391 13.0264 14.9217 13.4478 14.1716 14.1979C13.4214 14.9481 13 15.9655 13 17.0264Z",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.52637L11.5 11.5264",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.5264L14.5 19.5264",
    stroke: "#1C7CC4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServIcon2);
export default __webpack_public_path__ + "static/media/serv-icon2.be9a717d36543d3172fb3cde02d12af0.svg";
export { ForwardRef as ReactComponent };